import type { EmailTemplate } from '../../../pages/email-templates/api/useEmailTemplate';

/**
 * Le sujet par défaut d'un modèle d'e-mail, dans la locale du client — même
 * champ que le web (`ChatSendingMessage.tsx` : `template.default_subjects?.[locale]`,
 * pré-rempli à la sélection du template).
 *
 * Le serveur REFUSE un e-mail sans sujet (`MessageController.php` : « Le sujet
 * est requis pour envoyer un email »). D'où le repli à deux niveaux : l'objet
 * déjà calculé par le composeur (`sujetDeRepli`, un « Re: … » s'il y a un fil),
 * puis le nom du modèle en tout dernier recours — jamais une chaîne vide envoyée.
 */
export function sujetModele(modele: EmailTemplate, locale: string | null | undefined, sujetDeRepli: string): string {
    const localeClient = locale ?? 'fr';
    const parDefaut = modele.default_subjects?.[localeClient];
    if (parDefaut && parDefaut.trim()) return parDefaut.trim();

    const repli = sujetDeRepli.trim();
    return repli || modele.name;
}
